<template>
  <div :class="componentClassName">
    <div class="o-holiday-setting-list__items">
      <template v-for="(item, index) in items" :key="index">
        <a-holiday-setting-item
          v-model="items[index]"
          :item-index="index"
          @remove="removeItem(index)"
          @change="handleChange"
        />
      </template>
    </div>
    <div class="o-holiday-setting-list__control">
      <a-button
        id="add_holiday"
        :inline="true"
        variant="fill"
        color="primary"
        size="small"
        icon="plus"
        icon-color="white"
        label="休日追加"
        @click="handleAddItem"
      />
    </div>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AHolidaySettingItem from '@/components/molecules/holiday-setting-item';
import AButton from '@/components/atoms/button';
import { cloneDeep } from 'lodash';
import { HOLIDAY_TYPE } from '@/libs/constants';

export default {
  name: 'o-holiday-setting-list',
  components: {
    AHolidaySettingItem,
    AButton,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    modelValue: {
      type: Object,
      default: null,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      items: [],
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('o-holiday-setting-list');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  watch: {
    modelValue: {
      handler(val, oldVal) {
        this.setCurrentValue(val);
      },
      deep: true,
    },
  },
  mounted() {
    if (this.modelValue) {
      this.setCurrentValue(this.modelValue);
    } else {
      this.setCurrentValue([
        {
          type: HOLIDAY_TYPE.NORMAL,
          value: null,
        },
      ]);
    }
  },
  methods: {
    handleAddItem() {
      this.items.push({
        type: HOLIDAY_TYPE.NORMAL,
        value: null,
      });
      this.emitEvent();
    },
    removeItem(index) {
      this.items.splice(index, 1);
      this.emitEvent();
    },
    setCurrentValue(val) {
      this.items.splice(0);
      if (Array.isArray(val)) {
        val.forEach(item => {
          this.items.push(item);
        });
      }
    },
    handleChange() {
      this.emitEvent();
    },
    emitEvent() {
      this.$emit('update:modelValue', cloneDeep(this.items));
    },
  },
};
</script>
